import { AnalyticsEvent } from '../../core/AnalyticsEvent'
import { SortAppliedEventSchema } from '../../schemas/sort/SortAppliedEventSchema'
import { getConfigFor } from '../../../../utils/configService'
import { SPLIT_FEATURES } from '../../../../utils/constants/feature'
import { CommonEventParams, getCommonParams } from '../../utils/CommonParams'
import { BUSINESS_VERTICAL, EVENT_CATEGORY } from '../../constants/EventHelper'

export interface SortAppliedEventParams extends CommonEventParams {
  BUSINESS_VERTICAL: string
  EVENT_CATEGORY: string
  STORE_ID_SAP: string | null
  STORE_ID_DBP: string | null
  SORT_CATEGORY: string
}

export interface CreateSortParams {
  SORT_CATEGORY: string;
  STORE_ID_SAP: string | null;
  STORE_ID_DBP: string | null;
}

export class SortAppliedEvent extends AnalyticsEvent {
  constructor(params: SortAppliedEventParams) {
    super(SortAppliedEventSchema, ['segment'])
    this.createEventObject(params)
  }
}

export async function trackSortAppliedEvent(
  sortAppliedParams: CreateSortParams
) {
  try {
    const { isEnabled = false } =
      getConfigFor(SPLIT_FEATURES.LEAP_CDP_RELEASE_SIX) || {}
    if (isEnabled) {
      const commonProperties = getCommonParams()
      const params: SortAppliedEventParams = {
        ...commonProperties,
        ...sortAppliedParams,
        BUSINESS_VERTICAL: BUSINESS_VERTICAL.GROCERY,
        EVENT_CATEGORY: EVENT_CATEGORY.GROCERY,
        PREVIOUS_SCREEN_SECTION: null  // no need to set previous screen section for this event
      }
      new SortAppliedEvent(params).track()
    }
  } catch (error) {
    console.error('Error tracking Sort Applied Event:', error)
  }
}
